



























































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import utility from '../common/utility';

@Component({})
export default class extends Vue {
    public errorMessage: string[] = [];
    public loginData = {
        mobile: '',
        pass: ''
    };

    public disableSubmitBtn = false;

    private submitted = false;

    get ErrorLength() {
        return this.errorMessage.length;
    }
    get mobileInvalid() {
        return !(/^\d{10,}$/.test(this.loginData.mobile));
    }
    get pwdInvalid() {
        return this.loginData.pass === '';
    }
    get disableSubmit() {
        return this.mobileInvalid || this.pwdInvalid;
    }

    public login() {
        // this.submitted boolean is used so that login is not called multiple times
        if ( !this.submitted ) {
            this.submitted = true;

            let error = false;
            this.errorMessage = [];

            if (this.loginData.mobile === '') {
                error = true;
                this.errorMessage.push('Please enter valid mobile number');
            }

            if (isNaN( +this.loginData.mobile )) {
                error = true;
                this.errorMessage.push('Mobile number must be numeric');
            }

            if (this.loginData.pass === '') {
                error = true;
                this.errorMessage.push('Please enter your prayer group password');
            }

            if (!error) {
                // disable submit button till user/login request is complete
                this.disableSubmitBtn = true;

                // call login api
                axios({
                    method: 'post',
                    url: utility.api('user/login'),
                    data: this.loginData
                })
                .then((response: any) => {
                    this.errorMessage = [];

                    utility.eventBus.$emit('user-info', response.data);

                    localStorage.user = JSON.stringify(response.data);

                    this.$router.push(utility.loginSuccessRoute);
                })
                .catch( (e) => {
                    this.errorMessage = [].concat(e.response.data);
                })
                .finally(() => {
                    this.disableSubmitBtn = this.submitted = false;
                });
            } else {
                this.submitted = false;
            }
        }
    }
    public closeError() {
        this.errorMessage = [];
    }
}
